/* eslint-disable jsx-a11y/media-has-caption */

import React from "react";

import { Icon, PlainButton, Thumbnail } from "@culturehq/components";

import tiktok from "images/social/tiktok.svg";

import Subtitles from "components/common/Subtitles";

const TiktokPreview = ({
  mediaRef,
  showVideoInfo,
  onShowVideoInfo,
  onPlay,
  imageUrl,
  data,
  profile,
  shareMessage,
  story,
  username
}) => (
  <>
    <div className="Body_Header Preview-User">
      <div className="Preview-User__Info-Container">
        <Thumbnail className="Thumbnail" image={profile.avatar.thumbUrl} title={profile.name} />
      </div>
      <div className="MainContainer">
        <div>
          <p className="Preview-User__Info Preview-User__Info-Name">{username || profile.name}</p>
        </div>
        <div className="Preview-area no-scrollbar">
          <span>{data?.text || shareMessage}</span>
        </div>
        <div className="gallery-lightbox__photo">
          <div className="gallery-lightbox__image-container" style={{ backgroundImage: `url(${imageUrl})` }} />
          {story.media.mediaType === "image" && (
            <img
              className="gallery-lightbox__photo--image"
              ref={mediaRef}
              src={imageUrl}
              alt={story.imageAlt || story.question.question}
            />
          )}
          {story.media.mediaType === "video" && (
            <>
              {showVideoInfo && (
                <div className="gallery-lightbox__video-play" onClick={onPlay}><Icon icon="play-filled" /></div>
              )}
              <video
                controls
                className="gallery-lightbox__main-image gallery-lightbox__main-video"
                onPause={() => onShowVideoInfo(true)}
                onPlay={() => onShowVideoInfo(false)}
                poster={`${story.media.thumbnail}?not-from-cache-please`}
                ref={mediaRef}
                src={story.media.url}
                disablePictureInPicture
                crossOrigin="anonymous"
                controlsList="nodownload"
              >
                <Subtitles media={story.media} />
              </video>
            </>
          )}
        </div>
      </div>
      <img className="social-icon" src={tiktok} alt="TikTok" />
    </div>
    <div className="Preview-Actions Tiktok-Buttons">
      <PlainButton className="Tiktok-Reactions__Btn">
        <svg viewBox="0 0 512.001 512.001" version="1.1">
          <path d="m256.001 477.407c-2.59 0-5.179-.669-7.499-2.009-2.52-1.454-62.391-36.216-123.121-88.594-35.994-31.043-64.726-61.833-85.396-91.513-26.748-38.406-40.199-75.348-39.982-109.801.254-40.09 14.613-77.792 40.435-106.162 26.258-28.848 61.3-44.734 98.673-44.734 47.897 0 91.688 26.83 116.891 69.332 25.203-42.501 68.994-69.332 116.891-69.332 35.308 0 68.995 14.334 94.859 40.362 28.384 28.563 44.511 68.921 44.247 110.724-.218 34.393-13.921 71.279-40.728 109.632-20.734 29.665-49.426 60.441-85.279 91.475-60.508 52.373-119.949 87.134-122.45 88.588-2.331 1.354-4.937 2.032-7.541 2.032z" />
        </svg>
      </PlainButton>
      <PlainButton>
        <svg viewBox="0 0 512 492" version="1.1">
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="chat" transform="translate(256.000000, 245.928919) scale(-1, 1) translate(-256.000000, -245.928919) " fill="#000000" fillRule="nonzero">
              <path d="M255,0 C114.39,0 0,100.928 0,225 C0,277.412 28.9068471,322.605975 108.247852,387.356728 C169.689735,437.499881 242.078521,491.857838 256,491.857838 C258,491.857838 257,428.772809 257,428.772809 C257,428.772809 333.658466,426.702416 401,387.356728 C461.012498,352.293182 512,283.46592 512,225 C512,100.928 395.61,0 255,0 Z M137,270 C112.186,270 92,249.814 92,225 C92,200.186 112.186,180 137,180 C161.814,180 182,200.186 182,225 C182,249.814 161.814,270 137,270 Z M257,270 C232.186,270 212,249.814 212,225 C212,200.186 232.186,180 257,180 C281.814,180 302,200.186 302,225 C302,249.814 281.814,270 257,270 Z M377,270 C352.186,270 332,249.814 332,225 C332,200.186 352.186,180 377,180 C401.814,180 422,200.186 422,225 C422,249.814 401.814,270 377,270 Z" />
            </g>
          </g>
        </svg>
      </PlainButton>
      <PlainButton>
        <Icon icon="share" />
      </PlainButton>
    </div>
  </>
);

export default TiktokPreview;
